export default "__VITE_ASSET__DNVHNYR$__"